import Swal from "sweetalert2";

const Toast = Swal.mixin({
  toast: true,
  position: "top-end",
  showConfirmButton: false,
  timer: 8000,
  timerProgressBar: true,
  didOpen: (el) => {
    el.addEventListener("mouseenter", Swal.stopTimer);
    el.addEventListener("mouseleave", Swal.resumeTimer);
  },
});

export const toastSuccess = (title: string) =>
  Toast.fire({ icon: "success", title });

export const toastError = (title: string) =>
  Toast.fire({ icon: "error", title, timer: 10000 });

export const toastWarning = (title: string) =>
  Toast.fire({ icon: "warning", title });

export const toastInfo = (title: string) =>
  Toast.fire({ icon: "info", title });
